import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GruposService {

  constructor(private _http:HttpClient) { }

  setContratNumber(numeroContrato,grugru){
      return this._http.put(`${environment.api}grupos-afi/${grugru}/contrato/numero`,{numeroContrato});
  }
}
